/* Avichome upsell runtime – FBT, Quantity breaks (with per-item variants), Cart upsell */
(function () {
  var MAX_ROWS = 50;
  function fmt(cents) {
    var f = window.aviMoneyFormat || ('$' + '{{amount}}');
    var a = (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  }
  function off(cents, d) { return cents - Math.floor(cents * d / 100); }
  function hasPubSub() { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function mobile() { return window.matchMedia('(max-width: 749px)').matches; }

  async function refreshDrawer() {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
    var r = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    var sections = await r.json();
    d.classList.remove('is-empty');
    d.renderContents({ sections: sections });
  }
  async function applyCodes(list) {
    list = (list || []).filter(Boolean);
    if (!list.length) return;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var up = list.map(function (c) { return c.toUpperCase(); });
      var codes = (cart.discount_codes || []).map(function (x) { return x.code; })
        .filter(function (c) { return c && up.indexOf(c.toUpperCase()) === -1; });
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.concat(list).join(',') }) });
    } catch (e) { console.warn('[avi-upsell] discount', e); }
  }
  async function addItems(items, codes, errEl) {
    var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
    if (!r.ok) {
      var e = await r.json().catch(function () { return {}; });
      if (errEl) { errEl.textContent = e.description || e.message || 'Could not add to cart.'; errEl.hidden = false; }
      return false;
    }
    if (errEl) errEl.hidden = true;
    await applyCodes(codes);
    await refreshDrawer();
    if (hasPubSub() && typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'avi-upsell' });
    return true;
  }
  function qtyInput(sid) { return document.getElementById('Quantity-' + sid) || document.querySelector('input[name=quantity][form="product-form-' + sid + '"]'); }
  function currentQty(sid) { var q = qtyInput(sid); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
  function formVariantId(sid) { var i = document.querySelector('#product-form-' + sid + ' input[name=id]'); return i ? Number(i.value) : null; }

  var QB = {};   // sid -> api
  var fbts = [];

  /* ---------- Quantity breaks ---------- */
  function initQB(root) {
    var sid = root.dataset.section;
    var custom = root.querySelector('input[data-custom]');
    var customQty = root.querySelector('[data-custom-qty]');
    var vEl = root.querySelector('[data-avi-variants]');
    var variants = vEl ? JSON.parse(vEl.textContent) : null;
    var rowsBox = root.querySelector('[data-avi-rows]');
    var rowsEl = rowsBox && rowsBox.querySelector('[data-rows]');
    var picks = [];           // chosen variant id per item
    var touched = [];         // row edited by customer
    if (variants && customQty) customQty.max = MAX_ROWS;

    function vById(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === Number(id)) return variants[i]; return null; }
    function mainVariant() { var id = formVariantId(sid); return (variants && vById(id)) || (variants && variants[0]) || null; }
    function active() { return root.querySelector('input[type=radio]:checked'); }
    function activeQty() { var a = active(); return a ? Number(a.dataset.qty) : 1; }
    function usesRows() { return !!(variants && rowsBox && activeQty() >= 2); }

    function renderRows() {
      if (!rowsBox) return;
      var q = Math.min(activeQty(), MAX_ROWS), a = active();
      if (!usesRows()) { rowsBox.hidden = true; root.querySelectorAll('.avi-qb__tier').forEach(function (l) { l.classList.remove('has-rows'); }); return; }
      var def = mainVariant();
      for (var i = 0; i < q; i++) if (!picks[i] || !touched[i]) picks[i] = def ? def.id : variants[0].id;
      picks.length = q; touched.length = q;
      var html = '';
      for (var j = 0; j < q; j++) {
        html += '<label class="avi-qb__row"><span>#' + (j + 1) + '</span><select data-row="' + j + '" aria-label="Item ' + (j + 1) + ' option">';
        variants.forEach(function (v) {
          html += '<option value="' + v.id + '"' + (v.id === Number(picks[j]) ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
            v.title.replace(/[<>&"]/g, '') + (v.available ? '' : ' – sold out') + '</option>';
        });
        html += '</select></label>';
      }
      rowsEl.innerHTML = html;
      var lab = a.closest('label');
      root.querySelectorAll('.avi-qb__tier').forEach(function (l) { l.classList.toggle('has-rows', l === lab); });
      lab.parentNode.insertBefore(rowsBox, lab.nextSibling);
      rowsBox.hidden = false;
    }
    function base(q) { // full price of q items using chosen variants (when rows active)
      if (usesRows() && q === activeQty()) return picks.reduce(function (s, id) { var v = vById(id); return s + (v ? v.price : 0); }, 0);
      var mv = mainVariant(); return (mv ? mv.price : Number(root.dataset.price)) * q;
    }
    function paint() {
      root.querySelectorAll('input[type=radio]').forEach(function (r) {
        var q = Number(r.dataset.qty), d = Number(r.dataset.discount), lab = r.closest('label');
        var full = base(q), now = off(full, d);
        var nowEl = lab.querySelector('[data-now]'), was = lab.querySelector('[data-was]'), unit = lab.querySelector('[data-unit]');
        if (r.dataset.custom !== undefined) { if (nowEl) nowEl.textContent = fmt(now) + ' · ' + fmt(Math.round(now / q)) + '/ea'; }
        else { var cmpU = Number(root.dataset.cmp || 0), pU = Number(root.dataset.price); var wasV = (cmpU > pU && !usesRows()) ? cmpU * q : full; if (nowEl) nowEl.textContent = fmt(now); if (was) was.textContent = wasV > now ? fmt(wasV) : ''; if (unit) unit.textContent = fmt(Math.round(now / q)) + ' / each'; }
      });
    }
    function sync() {
      var sel = active(); if (!sel) return;
      root.querySelectorAll('.avi-qb__tier').forEach(function (l) { l.classList.toggle('is-active', l.contains(sel)); });
      var q = qtyInput(sid);
      if (q) { q.value = sel.dataset.qty; q.dispatchEvent(new Event('change', { bubbles: true })); }
      root.dataset.pending = sel.dataset.code || '';
      renderRows(); paint();
      fbts.forEach(function (f) { if (f.sid === sid) f.recalc(); });
    }
    if (custom && customQty) {
      var min = Number(custom.dataset.min);
      var setCustom = function (n) {
        n = Math.max(min, Math.min(Number(customQty.max) || 999, parseInt(n, 10) || min));
        customQty.value = n; custom.dataset.qty = n; custom.checked = true; sync();
      };
      root.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function (ev) { ev.preventDefault(); setCustom(Number(customQty.value) + Number(b.dataset.step)); });
      });
      customQty.addEventListener('change', function () { setCustom(customQty.value); });
      customQty.addEventListener('click', function (ev) { ev.stopPropagation(); if (!custom.checked) { custom.checked = true; sync(); } });
    }
    if (!root.querySelector('input[type=radio]:checked')) { var f0 = root.querySelector('input[type=radio]'); if (f0) f0.checked = true; }
    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.matches && t.matches('select[data-row]')) {
        var i = Number(t.dataset.row); picks[i] = Number(t.value); touched[i] = true; paint();
        fbts.forEach(function (f) { if (f.sid === sid) f.recalc(); });
        return;
      }
      if (t.type === 'radio') sync();
    });
    sync();
    QB[sid] = {
      root: root,
      usesRows: usesRows,
      syncQty: function () { var q = qtyInput(sid); if (q) q.value = activeQty(); },
      base: function () { return base(activeQty()); },
      items: function () {
        if (!usesRows()) return [{ id: formVariantId(sid), quantity: activeQty() }];
        var map = {}, order = [];
        picks.forEach(function (id) { if (!map[id]) { map[id] = 0; order.push(id); } map[id]++; });
        return order.map(function (id) { return { id: Number(id), quantity: map[id] }; });
      },
      code: function () { return root.dataset.pending || ''; },
      onVariantChange: function (v) { root.dataset.price = v.price; root.dataset.cmp = v.compare_at_price || 0; renderRows(); paint(); }
    };
  }

  /* ---------- Frequently bought together ---------- */
  function initFBT(root) {
    var sid = root.dataset.section, d = Number(root.dataset.discount || 0);
    var main = root.querySelector('[data-main]');
    function mainBase() { var qb = QB[sid]; return qb ? qb.base() : Number(main.dataset.unit) * currentQty(sid); }
    function recalc() {
      var qty = currentQty(sid), full = mainBase(), offers = 0, t = 0, w = 0;
      root.querySelectorAll('input[data-variant]').forEach(function (cb) {
        cb.closest('.avi-fbt__item').classList.toggle('is-off', !cb.checked);
        if (cb.checked) { offers++; t += Number(cb.dataset.price); w += Number(cb.dataset.was); }
      });
      var mainNow = offers > 0 ? off(full, d) : full;
      t += mainNow; w += full;
      var mn = root.querySelector('[data-main-now]'); if (mn) mn.textContent = fmt(mainNow);
      var mw = root.querySelector('[data-main-was]'); if (mw) mw.textContent = mainNow < full ? fmt(full) : '';
      var mq = root.querySelector('[data-main-qty]'); if (mq) mq.textContent = qty > 1 ? '× ' + qty : '';
      root.querySelector('[data-total]').textContent = fmt(t);
      root.querySelector('[data-total-was]').textContent = w > t ? fmt(w) : '';
      var lbl = root.querySelector('[data-btn-label]');
      if (lbl) lbl.textContent = offers > 0 ? 'Add bundle to cart (' + (offers + qty) + ' items)' : 'Add to cart';
    }
    root.addEventListener('change', recalc);
    recalc();
    var btn = root.querySelector('[data-fbt-add]');
    btn.addEventListener('click', async function () {
      btn.classList.add('loading'); btn.disabled = true;
      var qb = QB[sid];
      var items = qb ? qb.items() : [{ id: formVariantId(sid) || Number(root.dataset.mainVariant), quantity: currentQty(sid) }];
      var n = 0;
      root.querySelectorAll('input[data-variant]:checked').forEach(function (cb) { n++; items.push({ id: Number(cb.dataset.variant), quantity: 1 }); });
      await addItems(items, n > 0 ? [root.dataset.code] : (qb ? [qb.code()] : []), root.querySelector('[data-error]'));
      btn.disabled = false; btn.classList.remove('loading');
    });
    var entry = { root: root, recalc: recalc, sid: sid, home: root.parentNode, homeNext: root.nextSibling };
    fbts.push(entry);
    placeFBT(entry);
  }
  function placeFBT(e) {
    var form = document.getElementById('product-form-' + e.sid);
    var pay = form && form.querySelector('.shopify-payment-button');
    if (mobile() && pay) {
      if (e.root.nextElementSibling !== pay) pay.parentNode.insertBefore(e.root, pay);
      e.root.classList.add('is-inline');
    } else if (e.root.parentNode !== e.home && e.home && e.home.isConnected) {
      e.home.insertBefore(e.root, e.homeNext && e.homeNext.parentNode === e.home ? e.homeNext : null);
      e.root.classList.remove('is-inline');
    }
  }
  var placeTimer;
  function placeAll() { clearTimeout(placeTimer); placeTimer = setTimeout(function () { fbts.forEach(placeFBT); }, 50); }
  window.addEventListener('resize', placeAll);
  new MutationObserver(function () { if (fbts.some(function (e) { return !e.root.isConnected; })) placeAll(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  /* Intercept the main "Add to cart" when the customer mixes variants */
  document.addEventListener('submit', async function (ev) {
    var form = ev.target; var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid || fid.indexOf('product-form-') !== 0) return;
    var qb = QB[fid.replace('product-form-', '')];
    if (qb) qb.syncQty();
    if (!qb || !qb.usesRows()) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var btn = form.querySelector('[type=submit]');
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
    await addItems(qb.items(), [qb.code()], null);
    if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
  }, true);

  function init() {
    document.querySelectorAll('.avi-qb:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initQB(el); });
    document.querySelectorAll('.avi-fbt:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initFBT(el); });
    if (hasPubSub() && !window.__aviSubscribed) {
      window.__aviSubscribed = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        var qb = document.querySelector('.avi-qb'); var code = qb && qb.dataset.pending;
        if (code) applyCodes([code]).then(refreshDrawer);
      });
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant; if (!v) return;
        Object.keys(QB).forEach(function (k) { QB[k].onVariantChange(v); });
        fbts.forEach(function (f) { var m = f.root.querySelector('[data-main]'); if (m) m.dataset.unit = v.price; f.recalc(); });
        placeAll();
      });
    }
  }
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-avi-add]'); if (!btn) return;
    e.preventDefault(); btn.disabled = true; btn.textContent = '...';
    await addItems([{ id: Number(btn.dataset.aviAdd), quantity: 1 }], [], null);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { Object.keys(QB).forEach(function (k) { QB[k].syncQty(); }); });
})();
